@if (label) {
  <h4>
    {{ label }}
    @if (required) {
      <span class="required-marker" aria-hidden="true">*</span>
    }
  </h4>
}
@if (control) {
  <mat-radio-group
    [attr.aria-label]="label | translate"
    [formControl]="control"
    class="example-radio-group"
    [ngClass]="layout"
    [attr.aria-required]="required"
    (change)="onChange($event)"
  >
    @for (option of options; track option.id) {
      <mat-radio-button
        [value]="option.id"
        [checked]="control ? control.value === option.id : option.id === selected"
      >
        @if (optionLabelTemplate) {
          <ng-container
            *ngTemplateOutlet="optionLabelTemplate; context: { label: option.name }"
          ></ng-container>
        } @else {
          <span class="ui-selection-label">{{ option.name | translate }}</span>
        }
      </mat-radio-button>
    }
  </mat-radio-group>
  @if (required && control.invalid && (control.touched || control.dirty)) {
    <mat-error>{{ 'required' | translate }}</mat-error>
  }
}
